"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    // write code here
    var container = document.createElement("div");
    if (container) container.className = "notification notification ".concat(type);
    container.style.top = posTop + "px";
    container.style.right = posRight + "px";
    var titleEl = document.createElement("h2");
    titleEl.className = "title";
    titleEl.textContent = title;
    var descriptionEl = document.createElement("p");
    descriptionEl.className = "description";
    descriptionEl.textContent = description;
    container.append(titleEl, descriptionEl);
    document.body.append(container);
    setTimeout(function() {
        container.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.5485ce42.js.map
